import { PropsWithChildren, useEffect, useRef, useState } from 'react'

interface LazyInViewProps {
  rootMargin?: string
  minHeight?: string | number
  className?: string
}

export default function LazyInView({
  children,
  rootMargin = '240px',
  minHeight,
  className,
}: PropsWithChildren<LazyInViewProps>) {
  const ref = useRef<HTMLDivElement>(null)
  const [isInView, setIsInView] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || isInView) return

    if (typeof IntersectionObserver === 'undefined') {
      setIsInView(true)
      return
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true)
          observer.disconnect()
        }
      },
      { rootMargin },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [isInView, rootMargin])

  return (
    <div ref={ref} className={className} style={minHeight ? { minHeight } : undefined}>
      {isInView ? children : null}
    </div>
  )
}
